export class Api {
  constructor() {
    throw new Error("This is a singleton class.");
  }

  static baseUrl = "https://api.staging.shadow.do";

  static get = async (path, { query, headers = null, errorDetail = false }) => {
    try {
      console.log(query);
      console.log(headers);
      console.log(errorDetail);
      // Your GET request logic goes here
    } catch (e) {
      // Your error handling logic goes here
    }
  };
}

// export const get = async (path, { query, headers, errorDetail = false }) => {
//   try {
//     console.log(query);
//     console.log(headers);
//     console.log(errorDetail);
//     // Your GET request logic goes here
//   } catch (e) {
//     // Your error handling logic goes here
//   }
// };
